<template>
  <div :class="classNames" v-cloak>
    <template v-if="portrait && allowUseMember">
      <div class="head-portrait">
        <img class="avatar-back" :src="portrait" alt="avatar" v-if="!isIAP" />
        <div
          class="avatar-wrapper"
          v-lazy-container="{
            selector: 'img',
            error: require(`@/assets/images/common/icon/avatar.png`),
          }"
        >
          <img
            class="avatar"
            alt=""
            :data-src="
              avatarUrl
                ? avatarUrl
                : require(`@/assets/images/common/icon/avatar.png`)
            "
          />
        </div>
      </div>
    </template>
    <template v-else>
      <div class="head-portrait original-portrait">
        <div
          class="avatar-wrapper"
          v-lazy-container="{
            selector: 'img',
            error: require(`@/assets/images/common/icon/avatar.png`),
          }"
        >
          <img
            class="avatar"
            alt=""
            :data-src="
              avatarUrl
                ? avatarUrl
                : require(`@/assets/images/common/icon/avatar.png`)
            "
          />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    name: 'UserAvatar',
    components: {},
    props: {
      isIAP: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        portrait: '',
        avatarUrl: '',
      }
    },
    computed: {
      ...mapState(['userInfo', 'members', 'allowUseMember', 'isApp']),
      classNames() {
        let classNames = ['user-avatars']
        let bindAppClass = this.isApp ? 'user-avatars-app' : ''
        bindAppClass && classNames.push(bindAppClass)
        return classNames
      },
    },
    watch: {
      members: {
        handler(newVal) {
          const { userInfo } = newVal

          this.portrait = userInfo && userInfo.portrait ? userInfo.portrait : ''
        },
        deep: true,
        immediate: true,
      },
      userInfo: {
        handler(newVal) {
          this.avatarUrl = newVal && newVal.avatarUrl ? newVal.avatarUrl : ''
        },
        deep: true,
        immediate: true,
      },
    },
    created() {},
    beforeDestroy() {},
    methods: {},
  }
</script>

<style scoped lang="scss" src="./index.scss"></style>
<style scoped lang="scss">
  [v-cloak] {
    display: none;
  }
  @media screen and (min-device-width: 1080px) {
    @import './index_pc.scss';
  }
</style>
